import { combineReducers } from 'redux'
import customerName from 'redux/reducers/customerName'
import settings from 'redux/reducers/settings'
import saveDeviceAndPassData from 'redux/reducers/saveDeviceAndPassData'
import identity from 'shared/redux/reducers/identity'
import message from 'shared/redux/reducers/message'
import customData from 'shared/redux/reducers/customData'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['customerName', 'identity', 'message', 'customData', 'settings', 'saveDeviceAndPassData'],
  stateReconciler: autoMergeLevel2,
}

const combinedReducers = combineReducers({
  customerName,
  identity,
  message,
  customData,
  settings,
  saveDeviceAndPassData,
})

const persistedReducer = persistReducer<any>(persistConfig, combinedReducers)

export default persistedReducer
